const createChainableTypeChecker = (validate) => {
  function checkType(isRequired, props, propName, componentName, location) {
    const component = componentName || 'ANONYMOUS';
    if (props[propName] == null) {
      if (isRequired) {
        return new Error(
          `Required ${propName} was not specified in ${component}.`
        );
      }
      return null;
    }
    return validate(props, propName, component, location);
  }

  const chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
};


export const CustomPropTypeConstructor = (typeName, passingConditionalFunction) => {
  const PropTypeConstructor = createChainableTypeChecker((props, propName, componentName) => {
    const { [propName]: value } = props;
    if (passingConditionalFunction(value) === false && value !== undefined) {
      return new Error(
        `Invalid prop ${propName} of type ${typeof value} supplied to ${componentName}, expected ${typeName}`
      );
    }
    return null;
  });
  return PropTypeConstructor;
};

export default CustomPropTypeConstructor;
